var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-row page-con h-full" },
    [
      _c(
        "el-card",
        { staticClass: "flex flex-col h-full prescription-con" },
        [
          _c(
            "el-select",
            {
              model: {
                value: _vm.currentPositionId,
                callback: function ($$v) {
                  _vm.currentPositionId = $$v
                },
                expression: "currentPositionId",
              },
            },
            _vm._l(_vm.positions, function (position) {
              return _c("el-option", {
                key: position.id,
                attrs: { label: position.name, value: position.id },
              })
            }),
            1
          ),
          _c("med-prescriptions", { ref: "patients", staticClass: "patients" }),
        ],
        1
      ),
      _c("el-card", { staticClass: "flex flex-col list-con" }, [
        _c(
          "div",
          { staticClass: "mb-10" },
          [
            _c("model-header", {
              attrs: { label: "处方" },
              scopedSlots: _vm._u([
                {
                  key: "options",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.prescription.head.code,
                              expression: "prescription.head.code",
                            },
                          ],
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.sendMed },
                        },
                        [_vm._v("发药 ")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("prescription-info"),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("model-header", { attrs: { label: "出库清单" } }),
            _c("out-list"),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }